import { render, staticRenderFns } from "./BlockDeliveryInformation.vue?vue&type=template&id=35ec0f7d&scoped=true&"
import script from "./BlockDeliveryInformation.vue?vue&type=script&lang=js&"
export * from "./BlockDeliveryInformation.vue?vue&type=script&lang=js&"
import style0 from "./BlockDeliveryInformation.vue?vue&type=style&index=0&id=35ec0f7d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ec0f7d",
  null
  
)

export default component.exports